<style scoped lang="less">
	ul {
		display: flex;
		align-items: center;

		li {
			margin-left: 2px;
			width: 15px;
			height: 15px;
			background-color: #D7D7D7;
		}

		.greenas {
			background: #09A706;
		}

		.rednas {
			background: #FF0000;
		}
	}
</style>
<template>
	<div class="dystagh">
		<div style="display: flex;align-items: center;">
			<ul v-if="numsnulls==null">
				<li class="greenas" v-for="(item,index) in numes" :key="index"></li>
			</ul>
			<ul>
				<li class="rednas" v-for="(item,index) in numev" :key="index"></li>
			</ul>
		</div>

		<ul v-if="numsnulls">
			<li v-for="(item,index) in 10" :key="index"></li>
		</ul>
	</div>
</template>

<script>
	export default {
		props: {
			nums: [Number, String],
			numsnull: String,

		},
		data() {
			return {
				numes: this.nums,
				numsnulls: this.numsnull
			}
		},
		mounted() {

		},
		computed: {
			numev() {
				return Number(10 - this.numes)
			}
		},
		methods: {

		}

	}
</script>
